import * as actionList from '../actions/reportrefundsactions';
import moment from 'moment';

const state = { 
    search:'', 
    page:0, 
    startDate: moment().startOf('month').toDate(), 
    endDate: moment().endOf('month').toDate(), 
    userId:-1, 
    countryId:null, 
    status: 1,
    threepsupplier: null
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    startDate: state => state.startDate,
    endDate: state => state.endDate,
    userId: state => state.userId,
    countryId: state => state.countryId,
    status: state => state.status,
    threepsupplier: state => state.threepsupplier
};

const actions = {
    [actionList.REPORTREFUNDS_SEARCH]: ({ commit }, search) => {
        commit(actionList.REPORTREFUNDS_SEARCH, search);
    },
    [actionList.REPORTREFUNDS_PAGE]: ({ commit }, page) => {
        commit(actionList.REPORTREFUNDS_PAGE, page);
    },
    [actionList.REPORTREFUNDS_STARTDATE]: ({ commit }, startDate) => {
        commit(actionList.REPORTREFUNDS_STARTDATE, startDate);
    },
    [actionList.REPORTREFUNDS_ENDDATE]: ({ commit }, endDate) => {
        commit(actionList.REPORTREFUNDS_ENDDATE, endDate);
    },
    [actionList.REPORTREFUNDS_USER]: ({ commit }, userId) => {
        commit(actionList.REPORTREFUNDS_USER, userId);
    },
    [actionList.REPORTREFUNDS_COUNTRY]: ({ commit }, countryId) => {
        commit(actionList.REPORTREFUNDS_COUNTRY, countryId);
    },
    [actionList.REPORTREFUNDS_STATUS]: ({ commit }, status) => {
        commit(actionList.REPORTREFUNDS_STATUS, status);
    },
    [actionList.REPORTREFUNDS_THREEPSUPPLIER]: ({ commit }, threepsupplier) => {
        commit(actionList.REPORTREFUNDS_THREEPSUPPLIER, threepsupplier);
    }
};

const mutations = {
    [actionList.REPORTREFUNDS_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionList.REPORTREFUNDS_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionList.REPORTREFUNDS_STARTDATE]: (state, startDate) => {
        state.page = 0;
        state.startDate = startDate;
    },
    [actionList.REPORTREFUNDS_ENDDATE]: (state, endDate) => {
        state.page = 0;
        state.endDate = endDate;
    },
    [actionList.REPORTREFUNDS_USER]: (state, userId) => {
        state.page = 0;
        state.userId = userId;
    },
    [actionList.REPORTREFUNDS_COUNTRY]: (state, countryId) => {
        state.page = 0;
        state.countryId = countryId;
    },
    [actionList.REPORTREFUNDS_STATUS]: (state, status) => {
        state.page = 0;
        state.status = status;
    },
    [actionList.REPORTREFUNDS_THREEPSUPPLIER]: (state, threepsupplier) => {
        state.page = 0;
        state.threepsupplier = threepsupplier;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};